import { render, staticRenderFns } from "./twitter-trend.vue?vue&type=template&id=6d09ddfd&scoped=true&"
import script from "./twitter-trend.vue?vue&type=script&lang=js&"
export * from "./twitter-trend.vue?vue&type=script&lang=js&"
import style0 from "./twitter-trend.vue?vue&type=style&index=0&id=6d09ddfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09ddfd",
  null
  
)

export default component.exports